<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  // metaInfo () {
  //   return {
  //     title: "Benediktus Zebua",
  //     meta: [
  //               { name: 'description', content:  'Epiloge is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.'},
  //               { property: 'og:title', content: "Epiloge - Build your network in your field of interest"},
  //               { property: 'og:site_name', content: 'Epiloge'},
  //               {property: 'og:type', content: 'website'},    
  //               {name: 'robots', content: 'index,follow'} 
  //           ]
  //   }
  // }
}
</script>
